import InternalTableRowItem from '@/ecm/models/internalTable/InternalTableRowItem';

export default class InternalTableRow {
    constructor (dto) {
        this.items = [];
        this.id = 0;
        if (dto) {
            this.id = dto.Id;
            this.items = dto.Items.map(rowDto => new InternalTableRowItem(rowDto.Column, rowDto.Value));
        }
    }

    getValue () {
        return this.items.filter(r => r.column.linkableColumn)[0].value;
    }

    toDto () {
        return {
            Id: isNaN(this.id) ? 0 : this.id,
            Items: this.items.map(row => row.toDto()),
        };
    }
}
